/** Automated QC (1.0.0-rc.8): profiles, the workspace settings, an asset's runs and one run with its findings. */
import { useQuery } from '@tanstack/react-query';
import type { QcAvailabilityDTO, QcFindingDTO, QcProfileDTO, QcRunDTO, QcSettings } from '@prism/contracts';
import { api } from '../client';
import { queryKeys } from '../queryKeys';

export type QcRunDetail = QcRunDTO & { findings: QcFindingDTO[] };

export function useQcProfiles(enabled = true) {
  return useQuery({
    queryKey: queryKeys.qcProfiles(),
    queryFn: () => api<{ items: QcProfileDTO[]; defaultProfileId: string | null; uploads: QcSettings['uploads'] }>('/api/v1/qc/profiles'),
    enabled,
    staleTime: 30_000,
  });
}

export function useQcSettings(enabled = true) {
  return useQuery({ queryKey: queryKeys.qcSettings(), queryFn: () => api<QcSettings>('/api/v1/qc/settings'), enabled });
}

export function useAssetQc(assetId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.assetQc(assetId),
    queryFn: () => api<{ availability: QcAvailabilityDTO; canRun: boolean; canRerun: boolean; items: QcRunDTO[] }>(`/api/v1/assets/${assetId}/qc`),
    enabled: Boolean(assetId),
  });
}

export function useQcRun(runId: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.qcRun(runId),
    queryFn: () => api<QcRunDetail>(`/api/v1/qc/runs/${runId}`),
    enabled: Boolean(runId),
  });
}
